// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"vr_a bhb_b"};